import { action, makeObservable, observable } from 'mobx';

import { IUserModel, UserModel } from 'shared/models';
import { ModelCast } from "shared/casts";

import { Model } from './Model';

export interface ICompanyBestDesignerModel {
    id: number,
    tinetsCount: number,
    level: number,
    completedTasksCount: number,
    tinetteIcon: string;
    ratingPosition: number,
    user: IUserModel;
}

export class CompanyBestDesignerModel extends Model implements ICompanyBestDesignerModel {
    casts = {
        user: new ModelCast(UserModel),
    };

    id = 0;
    tinetsCount = 0;
    level = 0;
    completedTasksCount = 0;
    ratingPosition = 0;
    tinetteIcon = "";
    user: UserModel = new UserModel();

    constructor(payload: ICompanyBestDesignerModel) {
        super();

        makeObservable(this, {
            id: observable,
            tinetsCount: observable,
            level: observable,
            completedTasksCount: observable,
            tinetteIcon: observable,
            ratingPosition: observable,
            user: observable,
            update: action,
        });

        this.update(payload);
    }
}
